<div class="modal" data-id="aud-modal" hidden>
  <div class="modal__backdrop" data-id="aud-backdrop"></div>

  <div class="modal__dialog" role="dialog" aria-modal="true" aria-labelledby="aud-title">
    <header class="modal__header">
      <h2 class="modal__title" id="aud-title"><%= _lcs( 'Benutzerdetails' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="aud-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <dl class="modal__dl">
        <dt><%= _lcs( 'Name' ) %></dt><dd data-id="aud-name">—</dd>
        <dt><%= _lcs( 'E-Mail' ) %></dt><dd data-id="aud-email">—</dd>
        <dt><%= _lcs( 'Rollen' ) %></dt><dd data-id="aud-roles">—</dd>
        <dt><%= _lcs( 'Status' ) %></dt><dd data-id="aud-status">—</dd>
        <dt><%= _lcs( 'Erstellt am' ) %></dt><dd data-id="aud-created">—</dd>
        <dt><%= _lcs( 'Aktualisiert am' ) %></dt><dd data-id="aud-updated">—</dd>
        <dt>ID</dt><dd data-id="aud-id" class="modal__dl-mono">—</dd>
      </dl>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="aud-close-btn"><%= _lcs( 'Schließen' ) %></button>
    </footer>
  </div>
</div>
